export let InsertDraftPosition = /*#__PURE__*/function (InsertDraftPosition) {
  InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
  InsertDraftPosition["START"] = "START";
  InsertDraftPosition["END"] = "END";
  InsertDraftPosition["INSIDE"] = "INSIDE";
  return InsertDraftPosition;
}({});